module.exports = __webpack_public_path__ + "img/whatsapp-icon.34d08432.png";